import { createStore, Store } from 'redux';
import { devToolsEnhancer } from 'redux-devtools-extension';
import { rootReducer } from './rootReducer';
import { authListener } from './auth/listener';

export function addListeners(_store: Store): void {
    authListener(_store);
}

const store: Store = createStore(rootReducer, devToolsEnhancer({}));

export default store;
